import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Col, FormGroup, Label, Input, Row, Card, Container, CardBody, Button, InputGroup, InputGroupText } from "reactstrap";
import { Formik } from "formik";
import useAxios from 'hooks/useAxios';
import plus from "assets/icon/Add-White-Icon.svg";


let querydata = [];
let sqlConnectionsdata = [];
let parametername = [];
let queryIdvalue;
let SearchButton = false;

const QueryToolDraw = (props) => {
    const API = useAxios();

    const {
        saveQueryReport
    } = props;

    const [loading, setLoading] = useState(false);
    const [reportname, setreportname] = useState('');
    const [parameternameval, setparameternameval] = useState([]);
    const [requestedbyval, setrequestedbyval] = useState('');
    const [queryid, setqueryid] = useState(0);
    const [connectionId, setconnectionId] = useState(0);

    useEffect(() => {
        Getqueryname();
        reset();
        SearchButton = false;
    }, []);
    const reset = () => {
        sqlConnectionsdata = []
        setqueryid(0),
            setconnectionId(0)
        setreportname("");
        setparameternameval([]);
        setrequestedbyval("");
        queryIdvalue = 0;
        GetsqlConnectionsdata();
        GetQueryParameter();
        SearchButton = false;
    };
    const Getqueryname = async () => {
        querydata = [];
        sqlConnectionsdata = [];
        try {
            const { data } = await API.get(`/queryTool/getqueries`, {
                hasDefaultURL: false,
            });
            if (data) {
                for (var x in data) {
                    querydata.push({ "value": data[x].queryId, "label": data[x].queryName });
                };
            }
            setLoading(false)
        } catch (err) {
        };
    };
    const GetsqlConnectionsdata = async () => {

        setLoading(true);
        sqlConnectionsdata = [];
        try {
            const { data } = await API.get(`/queryTool/getsqlconnections/${queryIdvalue}`, {
                hasDefaultURL: false,
            });
            if (data) {
                for (var x in data) {
                    sqlConnectionsdata.push({ "value": data[x].connectionId, "label": data[x].connectionName });
                };
            }
            setLoading(false)
        } catch (err) {
        };
    };
    const GetQueryParameter = async () => {

        setLoading(true);
        parametername=[];
        setparameternameval([]);
        try {
            const { data } = await API.get(`/queryTool/getqueryparameter/${queryIdvalue}`, {
                hasDefaultURL: false,
            });
            if (data) {
                for (var x in data) {
                    parametername.push({
                        "isRequired": data[x].isRequired,
                        "paramDisplayName": data[x].paramDisplayName,
                        "parameterDescription": data[x].parameterDescription,
                        "parameter": data[x].parameter,
                        "defaultValue": data[x].defaultValue
                    });
                };
                setparameternameval(parametername);
            }
            setLoading(false)
        } catch (err) {
        };
    };
    const handleQueryNamechange = async (e) => {
        queryIdvalue = e.target.value;
        setqueryid(e.target.value);
        GetsqlConnectionsdata();
        GetQueryParameter();
        SearchButton = false;

    };
    const handleConnectionchange = async (e) => {
        setconnectionId(e.target.value);
        SearchButton = false;
    };
    const handlereportName = async (e) => {
        setreportname(e.target.value)

    };
    const handlerequestedBy = async (e) => {
        setrequestedbyval(e.target.value)
    };
    const handlePatientname = async (e, row) => {
        SearchButton = false;
        var rowdata = e.target.value;
        setparameternameval((newparams) =>
            newparams.map((p) =>
                p.parameter === row.parameter ? { ...p, defaultValue: rowdata } : p)
        )
    };
  

    const handleSubmit = async (val, actions) => {
        let values = {}
        let payload = parameternameval.map(({ parameter, defaultValue }) => ({
            [parameter]: defaultValue
        }))
        let payloadjson = JSON.stringify(payload);
        const parsedData = JSON.parse(payloadjson);
        const result = parsedData.reduce((acc, item) => {
            return { ...acc, ...item };
        }, {});
        if (connectionId == 0 && queryid == 0 || queryid == 0 || connectionId == 0) {
            return SearchButton = true;

        }
        for (var x in parameternameval) {
            if ((parameternameval[x].isRequired == true && parameternameval[x].defaultValue == null)||(parameternameval[x].isRequired == true && parameternameval[x].defaultValue == "" )) {
                return SearchButton = true;
            }
        }
        let valujson = JSON.stringify(result);
        values.queryid = queryid;
        values.connectionId = connectionId;
        values.reportnameval = reportname;
        values.parameterName = valujson;
        values.requestedbyval = requestedbyval;
        values.connectionId = connectionId;

        await saveQueryReport(values);
    };
    return (
        <Formik
            initialValues={''}
            onSubmit={handleSubmit}
            enableReinitialize={true}
            children={(props) => {
                const { handleSubmit } = props;
                return (
                    <Container fluid className='my-0'>

                        <div className='border-0 '>
                            <div className=''>
                                 <h5 className="f-16 text-primary font-weight-600" style={{alignContent:"center"}}>
Report Details              </h5>
<hr/>
                                <div>
                                    <Row sm={5}>
                                        <Col md={6} sm={6} xs={6}>
                                            {' '}
                                            <FormGroup>
                                                <Label for='reportName'>Report Name</Label>
                                                <Input
                                                    key='reportName'
                                                    id='reportName'
                                                    name='reportName'
                                                    type='text'
                                                    autoComplete='off'
                                                    value={reportname}
                                                    onChange={handlereportName}
                                                    label='Report Name'
                                                    maxLength={100}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6} sm={6} xs={6}>
                                            {' '}
                                            <FormGroup>
                                                <Label for='requestedBy'>Requested By</Label>
                                                <Input
                                                    key='requestedBy'
                                                    label='Requested By'
                                                    id='requestedBy'
                                                    name='requestedBy'
                                                    type='text'
                                                    autoComplete='off'
                                                    value={requestedbyval}
                                                    onChange={handlerequestedBy}
                                                    maxLength={100}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6} sm={6} xs={6}>
                                            {' '}
                                            <FormGroup>
                                                <Label for='queryName'>Report Template {" *"}</Label>
                                                <Input
                                                    type='select'
                                                    onChange={(e) => handleQueryNamechange(e)}
                                                    required
                                                    value={queryid}
                                                >
                                                    <option value='0'>Select...</option>
                                                    {querydata.map((status) => {
                                                        const { value, label } = status;
                                                        return (
                                                            <option key={value} value={value}>
                                                                {label}
                                                            </option>
                                                        );
                                                    })};
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                        <Col md={6} sm={6} xs={6}>
                                            {' '}
                                            <FormGroup>
                                                <Label for='ConnectionID'>Connection{" *"}</Label>
                                                <Input
                                                    type='select'
                                                    onChange={(e) => handleConnectionchange(e)}
                                                    value={connectionId}
                                                    required
                                                >
                                                    <option value='0'>Select...</option>
                                                    {sqlConnectionsdata.map((status) => {
                                                        const { value, label } = status;
                                                        return (
                                                            <option key={value} value={value}>
                                                                {label}
                                                            </option>
                                                        );
                                                    })};
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                        {parameternameval.map((row, index) => {
                                            
                                                return (

                                                    <Col md={6} sm={6} xs={6} key={index}>
                                                        {' '}
                                                        <FormGroup>
                                                            <Label >{row.paramDisplayName}{row.isRequired == true ? " *" : ""}</Label>
                                                            <Input
                                                                id='paramDisplayName'
                                                                name='paramDisplayName'
                                                                type='text'
                                                                className={row.isRequired == true ? "required" : ""}
                                                                autoComplete='off'
                                                                value={row.defaultValue}
                                                                onChange={(e) => handlePatientname(e, row)}
                                                            />
                                                            <Label >{row.parameterDescription}</Label>
                                                        </FormGroup>
                                                    </Col>
                                                );
                                            
                                        })}
                                       
                                    </Row>
                                   
                                </div>
                            </div>
                        </div>
                         <Row className="d-flex justify-content-end" 
                        
                                        >
                                         {SearchButton && <div className="text-danger font-size-12">{"Please Enter required fields"}</div>}
                                        <Col md="auto" className="pt-4 mt-1"
                                         style={{position:"absolute",
                                            bottom:0,
                                            right:0,
                                            marginRight:"16px",
                                            marginBottom:"16px"
                                        }}
                                        
                                        >
                                            <Label>{""}</Label>
                                            <Button
                                            
                                                color="primary"
                                                className="search"
                                                // className="ms-2"
                                                onClick={handleSubmit}
                                            >
                                                                            <span className="right_5">
                              {" "}
                              <img src={plus} alt="" />
                            </span>{" "}
                                                Create 
                                            </Button>

                                            {/* <Button
                                                color="primary"
                                                className="ms-2"
                                                onClick={() => reset()}
                                            >
                                                Reset
                                            </Button> */}
                                        </Col>
                                    </Row>
                    </Container>
                );
            }}
        ></Formik>
    );
};

export default QueryToolDraw;
